




















import { Component, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import ViewpointFactorVisibilityEditor from '@/components/viewpoint-factor-visibility/ViewpointFactorVisibilityEditor.vue';
import Dialogs from '@/store/modules/Dialogs';
import Modelling from '@/store/modules/Modelling';
import { FactorGroup, FactorResource } from '@/api/model/FactorResource';
import { ViewpointFactorResource } from '@/api/model/ViewpointFactorResource';
import _ from 'lodash';
import { VisibilityDefinition } from '@/api/model/VisibilityDefinition';

const viewpointsModule = getModule(Viewpoints);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const dialogsModule = getModule(Dialogs);
@Component({
    components: { ViewpointFactorVisibilityEditor },
})
export default class ViewpointFactorVisibilityEditorVuexDialog extends Vue {
    private dialog = false;
    private processing = false;

    @Watch('factorResourceId')
    @Watch('viewpointId')
    private onIdChanges() {
        // console.log(this.factorResourceId);
        // console.log(this.viewpointId);
        // if (this.factorResourceId && this.viewpointId) {
        //     this.dialog = true;
        // } else {
        //     this.dialog = false;
        // }
    }
    @Watch('selectedResource')
    private openDialog(){
        if(this.selectedResource){
            this.dialog = true;
        }
    }

    get selectedResource() {
        return dialogsModule.selectedViewpointFactorVisibilityEdit;
    }

    get viewpointId() {
        if (!this.selectedResource) return;
        return this.selectedResource.viewpointId;
    }

    get factorResourceId() {
        if (!this.selectedResource) return;
        return this.selectedResource.factorResourceId;
    }

    get factors() {
        return this.getFilteredChildFactors('M', modellingModule.publishedModelFactorResources);
    }

    get viewpointFactorResource() {
        if (!this.factorResourceId || !this.viewpointId) return;
        return viewpointsModule.viewpointFactorResources[this.viewpointId][this.factorResourceId];
    }

    // kathy - loop through selected viewpoints and find 
    get selectedViewpointName() {
        // console.log(viewpointsModule.selectedViewpoints);
        if (this.viewpointId){
            const selectedViewpoints = viewpointsModule.selectedViewpoints;
            const selected = selectedViewpoints.find(x => x.viewpointId === this.viewpointId);
            if(selected && selected.hasOwnProperty("name")){
                return selected.name;
            }
        }
    }

    get factorName() {
        if (this.factorResourceId) {
            return modellingModule.publishedModelFactorResources[this.factorResourceId].name;
        }
    }

    // kathy
    get resource() {
        // console.log(this.viewpointFactorResource);
        if (this.viewpointFactorResource) {

            if (this.viewpointFactorResource.visibilityDefinition){
                return _.cloneDeep(this.viewpointFactorResource.visibilityDefinition);
            } else {
                return {};
            }
        }
        return {};
    }

    // kathy - computed function to get visibility resource
    // private getResource() {
    //     console.log('run');
    //     if (this.factorResourceId && this.viewpointId && this.viewpointFactorResources) {
    //         const viewpointFactorResource = this.viewpointFactorResources[this.viewpointId][
    //             this.factorResourceId
    //         ];
    //         if (viewpointFactorResource) {
    //             return _.cloneDeep(viewpointFactorResource.visibilityDefinition);
    //         } else {
    //             return {};
    //         }
    //     } else {
    //         return {};
    //     }
    // }

    private getFilteredChildFactors(
        factorGroupId: string,
        factors: { [id: string]: FactorResource }
    ): any[] {
        if (factorGroupId === this.factorResourceId) return [];
        let group = factors[factorGroupId] as FactorGroup;
        if (!group) return [];
        if (group.groupTypeDefinition && group.groupTypeDefinition.type === 'TABLE_FIXED')
            return [];
        return group.childrenIds
            .map((id) => factors[id])
            .filter((f) => f && f.id !== this.factorResourceId)
            .map((f) =>
                f.type === 'FACTOR'
                    ? [this.constructFactorInfo(group.name || '', f)]
                    : this.getFilteredChildFactors(f.id, factors)
            )
            .flat();
    }

    private constructFactorInfo(parentName: string, factor: FactorResource) {
        return {
            parentName: parentName,
            name: factor.name,
            id: factor.id,
        };
    }

    @Emit()
    private async submit(visibilityDefinition: VisibilityDefinition) {
        if (!this.viewpointId || !this.factorResourceId) return;
        let viewpointFactorResource: ViewpointFactorResource;
        if (this.viewpointFactorResource) {
            viewpointFactorResource = _.cloneDeep(this.viewpointFactorResource);
            viewpointFactorResource.visibilityDefinition = visibilityDefinition;
        } else {
            viewpointFactorResource = {
                viewpointId: this.viewpointId,
                id: this.factorResourceId,
                visibilityDefinition: visibilityDefinition,
            };
        }
        this.processing = true;
        await viewpointsModule.putViewpointFactor(viewpointFactorResource);
        this.processing = false;
        await dialogsModule.editViewpointFactorVisibility(null);
        this.dialog = false;
    }

    private async deleteClick() {
        if (this.viewpointFactorResource) {
            let viewpointFactorResource = _.cloneDeep(this.viewpointFactorResource);
            viewpointFactorResource.visibilityDefinition = undefined;
            this.processing = true;
            await viewpointsModule.putViewpointFactor(viewpointFactorResource);
            this.processing = false;
        }
        await dialogsModule.editViewpointFactorVisibility(null);
        this.dialog = false;
    }

    @Emit('cancel')
    private async cancel() {
        dialogsModule.editViewpointFactorVisibility(null);
        this.dialog = false;
    }
}
